import { Outlet, Navigate } from "react-router-dom";

const ConditionalRoute = ({ condition, redirectTo }) => {
  return condition() ? <Outlet /> : <Navigate to={redirectTo} />
}

export default ConditionalRoute;